﻿import { GridEditorDialog } from "@/Common/Helpers/GridEditorDialog";
import { SqlProcLookupParameterForm } from "@/ServerTypes/Data/SqlProcLookupParameterForm";
import { Decorators, WidgetProps } from "@serenity-is/corelib";
import { SqlProcLookupParameter } from "@/ServerTypes/Data/SqlProcLookupParameter";

@Decorators.registerClass("Matrix.Data.SqlProcLookupParameterDialog")
export class SqlProcLookupParameterDialog extends GridEditorDialog<SqlProcLookupParameter> {

    protected override getFormKey() { return SqlProcLookupParameterForm.formKey; }
    protected override getNameProperty() { return "Name"; }
    protected override getEntitySingular() { return "Parameter"; }

    protected form = new SqlProcLookupParameterForm(this.idPrefix);

    constructor(props?: WidgetProps<{}>) {
        super(props);
    }
}
